import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=5a33b74e&scoped=true"
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33b74e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a33b74e')) {
      api.createRecord('5a33b74e', component.options)
    } else {
      api.reload('5a33b74e', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=5a33b74e&scoped=true", function () {
      api.rerender('5a33b74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/target_two/form/components/table_form.vue"
export default component.exports